import React from "react";
import {
	Box,
	Button,
	Typography,
} from "@mui/material";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import "./OrdersEmptyState.scss";

const getEmptyStateDatePhrase = (dateRangeLabel) => {
	if (!dateRangeLabel) {
		return "";
	}
	if (dateRangeLabel.startsWith("Last ")) {
		return ` in the ${dateRangeLabel.toLowerCase()}`;
	}
	if (dateRangeLabel === "Today") {
		return " Today";
	}
	return ` in range ${dateRangeLabel}`;
};

export const OrdersEmptyState = ({
	dateRangeLabel,
	searchTerm = "",
	onWidenDateRange,
	onClearFilters,
	showWidenAction = true,
	clearFiltersDisabled = false,
}) => {
	const hasSearch = Boolean(searchTerm && searchTerm.trim());
	const datePhrase = getEmptyStateDatePhrase(dateRangeLabel);

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				textAlign: "center",
				py: 6,
				px: 2,
			}}
			data-testid="orders-empty-state"
		>
			<SearchOffOutlinedIcon
				sx={{ fontSize: 48, color: "text.secondary", mb: 2 }}
			/>

			<Typography variant="h6" gutterBottom>
				No orders found{datePhrase}
				{hasSearch ? (
					<>
						{" "}matching <Box component="span" className="orders-empty-search-term">{searchTerm.trim()}</Box>
					</>
				) : null}
			</Typography>

			<Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 420 }}>
				{hasSearch
					? `Nothing matches ${searchTerm.trim()} within your current filters.`
					: "Nothing matches within your current filters."}
			</Typography>

			<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "center" }}>
				{showWidenAction && (
					<Button
						variant="contained"
						color="primary"
						onClick={onWidenDateRange}
						data-testid="orders-widen-date-range"
					>
						Search last 12 months
					</Button>
				)}
				<Button
					variant="outlined"
					color="secondary"
					onClick={onClearFilters}
					disabled={clearFiltersDisabled}
					data-testid="orders-empty-clear-filters"
				>
					Clear filters
				</Button>
			</Box>
		</Box>
	);
};
